import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import PPQuestion from './Question'

export default class PPSlide {
    id = uuidv4()

    title = ''

    template = ''

    question = new Map()

    constructor(props = {}) {
        this.title = props.title ?? ''
        this.template = props.template ?? ''

        if (props.question instanceof Map) {
            this.question = props.question
        }

        makeAutoObservable(this)
    }

    get slideTitle() {
        if (this.title) return this.title

        return Array.from(this.question?.values()).map((q) => q.questionShortText).join('/')
    }

    getQuestionAtPosition(position) {
        return this.question.get(position)
    }

    addQuestion(position, question) {
        this.question.set(position, new PPQuestion(question, this.store))
    }

    removeQuestion(position) {
        this.question.delete(position)
    }

    updateTitle(event) {
        this.title = event.value
    }

    updateTemplate(template) {
        this.template = template
    }

    getQuestionCharts() {
        const questions = [...this.question.values()]

        return questions.map((q) => q.chart)
    }

    get questionIds() {
        const ids = []
        this.question.forEach((q) => {
            if (q.questionId) ids.push(q.questionId)
            if (q.kpiQuestionId) ids.push(q.kpiQuestionId)
            q.questions?.forEach((nested) => {
                if (nested?.questionId) ids.push(nested.questionId)
            })
        })
        return ids
    }

    questionIdsForSurvey(surveyId) {
        const ids = []
        this.question.forEach((q) => {
            if (q.surveyId !== surveyId) return
            if (q.questionId) ids.push(q.questionId)
            if (q.kpiQuestionId) ids.push(q.kpiQuestionId)
            q.questions?.forEach((nested) => {
                if (nested?.questionId) ids.push(nested.questionId)
            })
        })
        return ids
    }

    toJSON = () => ({
        id: this.id,
        title: this.title,
        template: this.template,
        question: Array.from(this.question.values()),
    })
}
